import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, Label } from 'semantic-ui-react'
import SubHeader from '../shared/subHeader/SubHeader'
import { Table } from 'semantic-ui-react'
import { VisionMode } from '../../utils/theme'
import { history } from '../../utils/history'
import { fetchContact } from '../../redux/actions/contact-action'
import ContactInfoView from '../contact/ContactInfoView'

class ContactView extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.fetchContact(this.props.match.params.id)
  }

  getHeaderActions = () => {
    return (
      <Fragment>
        <Button
          icon="reply"
          type="submit"
          content="Retour à la liste"
          color="black"
          onClick={() => {
            history.push('/settings/contacts')
          }}
        />
      </Fragment>
    )
  }

  render() {
    const { contact } = this.props
    return (
      <div className="ui content">
        <div className="ui segment">
          <SubHeader
            title={`${contact?.nom}`}
            actions={this.getHeaderActions()}
          />
          <div className="ui divider"></div>
          <div className="dt-top-container">
            <div className="content">
              <Table
                definition
                className={`${
                  this.props.theme.visionMode === VisionMode.AMELIORE
                    ? 'inverted'
                    : ''
                }`}
              >
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Code</Table.Cell>
                    <Table.Cell>{contact?.code}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Libellé</Table.Cell>
                    <Table.Cell>{contact?.nom}</Table.Cell>
                  </Table.Row>
                  {/* <Table.Row>
                    <Table.Cell>Fournisseur</Table.Cell>
                    <Table.Cell>
                      {contact?.isFournisseur ? 'Oui' : 'Non'}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Client</Table.Cell>
                    <Table.Cell>{contact?.isClient ? 'Oui' : 'Non'}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>OPM AGM</Table.Cell>
                    <Table.Cell>
                      {contact?.isOPM_AGM ? 'Oui' : 'Non'}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Gérant</Table.Cell>
                    <Table.Cell>
                      {contact?.isGerant ? 'Oui' : 'Non'}
                    </Table.Cell>
                  </Table.Row> */}
                  <Table.Row>
                    <Table.Cell>Adresse</Table.Cell>
                    <Table.Cell>
                      {contact?.adresse} - {contact?.complement} <br />
                      {contact?.codePostal} - {contact?.ville} <br />
                      {contact?.pays.libelleFR} <br />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Département</Table.Cell>
                    <Table.Cell>{contact?.departement}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Professionnel soumis à la TVA</Table.Cell>
                    <Table.Cell>{contact?.isTVA ? 'Oui' : 'Non'}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Numéro de TVA</Table.Cell>
                    <Table.Cell>{contact?.numeroTVA}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Numéro SIRET</Table.Cell>
                    <Table.Cell>{contact?.numeroSIRET}</Table.Cell>
                  </Table.Row>
                  {/* <Table.Row>
                    <Table.Cell>Communauté Européenne</Table.Cell>
                    <Table.Cell>{contact?.isCEE ? 'Oui' : 'Non'}</Table.Cell>
                  </Table.Row> */}
                  <Table.Row>
                    <Table.Cell>Email</Table.Cell>
                    <Table.Cell>{contact?.email}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Tél. Fixe</Table.Cell>
                    <Table.Cell>{contact?.telFixe}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Tél. Portable</Table.Cell>
                    <Table.Cell>{contact?.telPortable}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Fax</Table.Cell>
                    <Table.Cell>{contact?.fax}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Remise par défaut</Table.Cell>
                    <Table.Cell>{contact?.remiseParDefaut}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Mentions</Table.Cell>
                    <Table.Cell>
                      {contact?.mentions &&
                        contact.mentions.map((mention, index) => (
                          <Label size="medium" as="a" color="black" key={index}>
                            {`${mention.descriptionCourte} - ${mention.mention}`}
                          </Label>
                        ))}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
              <ContactInfoView
                contactInfos={contact?.contactInfos}
                theme={this.props.theme}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return { contact: state.contacts.contact, theme: state.theme }
}

export default connect(mapStateToProps, { fetchContact })(ContactView)
